import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/alarms/'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {
  ids: [],
  byId: {}
}

const alarmDefaults = {
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...alarmDefaults,
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      }
    case REMOVE: {
      const newState = {
        ...state,
        ids: [ ...state.ids.filter(id => id !== action.payload.id) ],
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function remove (id) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}
